<div class="container">
    <span class="close-btn" mat-dialog-close></span>
    <span class="img"></span>
    <span class="title">
        {{ "REASONS_REJECTION_SENT" | translate }}
    </span>
    <span class="description">
        {{ "REASONS_REJECTION_SENT_DESCRIPTION" | translate }}
    </span>
    <button mat-raised-button class="button accept-button" (click)="closeModal()"> 
        {{ "OKEY" | translate }}
    </button>
</div>